import React, { useState } from 'react';
import styled from 'styled-components';
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from 'react-beautiful-dnd';
import {
  useProjectMasterColumnsQuery,
  useUpdateProjectMasterColumnMutation,
  useUpdateProjectMasterColumnPositionMutation,
} from 'api';
import { Switch } from 'components/antd';
import { columnDef } from '../../views/client/list/projects/detail/preleads/usePreleadTable';
import { HorizontalThreeLines } from 'components/Ui/Icon';

export default () => {
  const { data: { projectMasterColumns } = {} } = useProjectMasterColumnsQuery({
    fetchPolicy: 'cache-and-network',
  });
  const [updateProjectMasterColumn] = useUpdateProjectMasterColumnMutation();
  const [updateProjectMasterColumnPosition] =
    useUpdateProjectMasterColumnPositionMutation({
      refetchQueries: ['projectMasterColumns'],
    });
  const [columns, setColumns] = useState(projectMasterColumns || []);

  const onDragEnd = (result: DropResult) => {
    if (!result.source || !result.destination) {
      return;
    }

    const sourceIndex = result.source.index + fixedColumn.length;
    const destIndex = result.destination.index + fixedColumn.length;

    const items = Array.from(columns);
    const [removed] = items.splice(sourceIndex, 1);
    items.splice(destIndex, 0, removed);

    setColumns(items);

    updateProjectMasterColumnPosition({
      variables: { id: removed.id, position: destIndex },
    });
  };

  React.useEffect(() => {
    setColumns(projectMasterColumns);
  }, [projectMasterColumns]);

  if (!columns) {
    return null;
  }

  const fixedColumn = columns.filter(
    (column) => columnDef[column.dataType]?.sticky,
  );
  const draggableColumn = columns.filter(
    (column) =>
      columnDef[column.dataType] && !columnDef[column.dataType]?.sticky,
  );

  return (
    <Container>
      <h4>表示項目初期設定</h4>
      <p>項目表示の初期設定を行うことができます</p>
      <Columns>
        {fixedColumn.map((column) => (
          <ColumnItem key={column.id}>
            <label>
              <div />
              {column.title}
            </label>
            <Switch
              size="small"
              checked={column.isDisplay}
              disabled={column.dataType === 'prelead_uuid'}
              onChange={(checked) =>
                updateProjectMasterColumn({
                  variables: {
                    id: column.id,
                    isDisplay: checked,
                  },
                })
              }
            />
          </ColumnItem>
        ))}
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {draggableColumn.map((column, index) => (
                  <Draggable
                    key={column.id}
                    draggableId={column.id}
                    index={index}>
                    {(provided, snapshot) => (
                      <ColumnItem
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        className={snapshot.isDragging ? 'dragging' : ''}>
                        <label>
                          <div {...provided.dragHandleProps}>
                            <HorizontalThreeLines />
                          </div>
                          {column.title}
                        </label>
                        <Switch
                          size="small"
                          checked={column.isDisplay}
                          onChange={(checked) =>
                            updateProjectMasterColumn({
                              variables: {
                                id: column.id,
                                isDisplay: checked,
                              },
                            })
                          }
                        />
                      </ColumnItem>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Columns>
    </Container>
  );
};

const Container = styled.div`
  width: 313px;
  font-size: 12px;
  padding: 1rem;
  background-color: #ffffff;
  box-shadow: 
  0 3px 6px -4px rgba(0, 0, 0, 0.12), 
  0 6px 16px 0 rgba(0, 0, 0, 0.08), 
  0 9px 28px 8px rgba(0, 0, 0, 0.05);

  h4 {
    font-size: 12px;
    font-weight: bold;
    color: #495058;
  }

  p {
    font-size: 12px;
    color: #899098;
  }
`;

const Columns = styled.div`
  margin-top: 1rem;
  max-height: 60vh;
  overflow: scroll;
`;

const ColumnItem = styled.div`
  display: flex;
  height: 2rem;
  justify-content: space-between;
  align-items: center;

  > label {
    margin: 0 !important;
    font-weight: bold;
    display: flex;
    align-items: center;

    div {
      width: 20px;

      svg:hover {
        cursor: grab;
      }
    }
  }
`;
